// Copyright (c) 2022 by Move Closer.

import { MappingConfig } from '@movecloser/front-core'

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export const loyaltyAdapterMap: MappingConfig = {
  friendsAndFamily: 'friends_and_family',
  kameleon: 'kameleon',
  milesAndMore: 'miles_and_more',
  milesAndMorePoints: 'miles_and_more_points',
  milesAndMorePointsLimit: 'miles_and_more_points_limit'
}
